import Home from '@/components/common/Home.vue';

export const reportRoutes = {
  path: '/report',
  component: Home,
  name: 'Report',
  redirect: '/report/index',
  meta: {
    title: 'Report',
  },
  children: [
    {
      path: 'index',
      component: () => import('@/views/report/CommonReport.vue'),
      meta: {
        title: 'Common Report',
      },
    },
    {
      path: 'adv',
      component: () => import('@/views/report/AdvReport.vue'),
      meta: {
        title: 'Adv/Source Report',
      },
    },
    {
      path: 'aff',
      component: () => import('@/views/report/BillReport.vue'),
      meta: {
        title: 'Aff Report',
      },
    },
    {
      path: 'postbackReport',
      component: () => import('@/views/report/PostbackReport.vue'),
      meta: {
        title: 'Postback Report',
      },
    },
    {
      path: 'event-pb',
      component: () => import('@/views/report/EventPostbackReport.vue'),
      meta: {
        title: 'Event Postback Report',
      },
    },
    {
      path: 'conversionReport',
      component: () => import('@/views/report/ConversionReport.vue'),
      meta: {
        title: 'Conversion Report',
      },
    },
    {
      path: 'simulate',
      component: () => import('@/views/report/SimulateReport.vue'),
      meta: {
        title: 'Simulate Report',
      },
    },
    {
      path: 'reject',
      component: () => import('@/views/report/RejectReport.vue'),
      meta: {
        title: 'Reject Report',
      },
    },
    {
      path: 'defaultTrcffic',
      component: () => import('@/views/report/DefaultTrafficReport.vue'),
      meta: {
        title: 'Default Traffic Report',
      },
    },
    {
      path: 'pid',
      component: () => import('@/views/report/PidReport.vue'),
      meta: {
        title: 'Pid Report',
      },
    },
    {
      path: 'event',
      component: () => import('@/views/report/EventReport.vue'),
      meta: {
        title: 'Event Report',
      },
    },
  ],
};
